<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <PageHeader :content="page.data.header" />
        <!-- Uncomment to use search bar on this page-->
        <!-- <SearchBar v-model="search" /> -->
        <ResourceList :resources="items as Document[]" />
        <PageSections :sections="page.data.sections" />
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {PageHeader, PageSections, ResourceList} from '@/components/sections'
import {useDocumentStore, usePageStore} from '@/stores'
import {SearchBar} from '@/components/blocks'
import {useSearch} from '@/composables'
import {ref} from 'vue'

export default {
  name: 'DocumentIndex',
  mixins: [ViewDataMixin],
  components: {PageHeader, PageSections, ResourceList, SearchBar},
  setup() {
    const documents = ref<Document[]>([])
    const {search, items} = useSearch(documents)
    return {search, items, documents}
  },
  data() {
    return {
      page: null as Page | null,
    }
  },
  methods: {
    async init() {
      const [page, documents] = await Promise.all([usePageStore().get('documents'), useDocumentStore().all()])

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
      this.documents = documents
    },
  },
}
</script>
